import React from "react";
import "../../../styles/CheckoutSummary.scss";

const CheckoutRequired = ({ ticket, ticketCount, selectedDate, selectedTime, onProceed, allCustomersValid }: any) => {
  const price = ticket ? parseFloat(ticket.price) : 0;
  const subtotal = price * ticketCount;
  const serviceFee = subtotal * 0.055;
  const total = subtotal + serviceFee;

  const disabled = !ticket || !selectedDate || !selectedTime || !allCustomersValid;

  return (
    <div className="checkout-section">
      <h3>Checkout Summary</h3>

      <div className="summary">
        <div className="item">
          <div>Quantity:</div>
          <div>{ticketCount}</div>
        </div>

        <div className="item">
          <div>Subtotal:</div>
          <div>₱{subtotal.toLocaleString()}</div>
        </div>

        <div className="item">
          <div>Convenience Fee:</div>
          <div>₱{serviceFee.toLocaleString()}</div>
        </div>

        <div className="item total">
          <strong>Total Amount:</strong>
          <strong>₱{total.toLocaleString()}</strong>
        </div>
      </div>

      <button
        disabled={disabled}
        className="checkout-btn"
        onClick={() => onProceed(ticket.id)}
      >
        Proceed to Checkout
      </button>
    </div>
  );
};

export default CheckoutRequired;
